module.exports = __webpack_public_path__ + "static/media/Artboard7.a16eb93a.png";